import React from 'react';
import TicketStub from '../';
import TicketStubContent from '../content';
import TicketStubOutline from '../outline';
import TicketStubInfo from '../ticket_stub_info';

const T = React.PropTypes;

export default class PriceTypeSelectorTemplate extends React.Component {
  static propTypes = {
    children: T.node
  };

  render () {
    return <TicketStub>
      <TicketStubOutline isBlue ovalColorClass="ticket_stub_outline__oval--my_tickets_gray" />
      <TicketStubContent dataComponent="ticket_stub">
        <TicketStubInfo>
          {this.props.children}
        </TicketStubInfo>
      </TicketStubContent>
    </TicketStub>;
  }
}



// WEBPACK FOOTER //
// ./frontend/react/components/common/ticket_stub/templates/pricetype_selector_template.js